(() => {
  const settings = document.querySelector('script[data-peptia-carousel-controls]');
  const labels = { previous: settings?.dataset.previous || 'Anterior', next: settings?.dataset.next || 'Siguiente' };
  const icon = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 12h12m-5-5 5 5-5 5" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const connected = new Map();
  const init = (root, track, prev, next, mode = 'existing') => {
    if (!root || !track || connected.has(root)) return;
    if ((!prev || !next) && mode !== 'scroll' && mode !== 'dots') return;
    let controls;
    if (!prev || !next) {
      controls = root.querySelector(':scope > .peptia-side-controls');
      if (controls) { prev=controls.querySelector('.peptia-side-button--prev'); next=controls.querySelector('.peptia-side-button--next'); }
      else {
        controls = document.createElement('div'); controls.className = 'peptia-side-controls';
        [prev, next] = ['previous','next'].map(direction => {
          const button = document.createElement('button'); button.type = 'button';
          button.setAttribute('aria-label', labels[direction]);
          if (track.id) button.setAttribute('aria-controls', track.id);
          controls.append(button); return button;
        });
        root.append(controls);
      }
    }
    prev.classList.add('peptia-side-button','peptia-side-button--prev');
    next.classList.add('peptia-side-button','peptia-side-button--next');
    prev.innerHTML = icon; next.innerHTML = icon;
    const abort = new AbortController(), options = { signal: abort.signal };
    const dots = () => [...root.querySelectorAll('.peptia-reviews__dot,.peptia-science__dot')];
    const update = () => {
      if (!root.isConnected) return;
      const box = root.getBoundingClientRect(), area = track.getBoundingClientRect();
      const media = track.querySelector('.pmc-field,.protocol-card,.card__media,.product__media,.peptia-pcard__media');
      let target = media ? media.getBoundingClientRect() : area;
      const height = target.height * (root.matches('peptia-objectives') ? .34 : .5);
      root.style.setProperty('--peptia-arrow-y', (target.top - box.top + height) + 'px');
      let overflow = track.scrollWidth > track.clientWidth + 3;
      if (mode === 'dots') overflow = dots().length > 1 && track.getClientRects().length > 0;
      if (mode === 'splide') overflow = track.querySelectorAll('.splide__slide:not(.splide__slide--clone)').length > 1 && !(prev.disabled && next.disabled);
      if (!track.clientWidth || !area.height) overflow = false;
      root.dataset.peptiaArrows = String(overflow);
      if (mode === 'scroll') { prev.disabled = track.scrollLeft < 2; next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2; }
      if (mode === 'dots') { const all=dots(), i=Math.max(0,all.findIndex(d=>d.classList.contains('is-active') || d.getAttribute('aria-selected') === 'true')); prev.disabled=i===0; next.disabled=i===all.length-1; }
    };
    if (mode === 'scroll' || mode === 'dots') {
      const go = direction => {
        const all = dots();
        if (all.length) {
          const index = Math.max(0, all.findIndex(d=>d.classList.contains('is-active') || d.getAttribute('aria-selected') === 'true'));
          all[Math.max(0,Math.min(all.length-1,index+direction))].click();
        } else {
          const step = track.firstElementChild?.getBoundingClientRect().width || track.clientWidth;
          const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          track.scrollBy({ left:direction*(step+gap), behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth' });
        }
        requestAnimationFrame(update);
      };
      prev.addEventListener('click',()=>go(-1),options); next.addEventListener('click',()=>go(1),options);
    }
    track.addEventListener('scroll',update,{...options,passive:true});
    const resize = new ResizeObserver(update); resize.observe(track); resize.observe(root);
    const changes = new MutationObserver(update); changes.observe(track,{attributes:true,subtree:true,attributeFilter:['class','style']});
    const dotParent = root.querySelector('.peptia-reviews__dots,.peptia-science__dots');
    if (dotParent) changes.observe(dotParent,{attributes:true,subtree:true,attributeFilter:['class','aria-selected']});
    connected.set(root,{abort,resize,changes}); update();
    document.fonts.ready.then(update);
  };
  const scan = () => {
    connected.forEach((entry,root)=>{if (!root.isConnected){entry.abort.abort();entry.resize.disconnect();entry.changes.disconnect();connected.delete(root);}});
    document.querySelectorAll('peptia-product-carousel').forEach(root=>init(root,root.querySelector('.pmc-track'),root.querySelector('.pmc-prev'),root.querySelector('.pmc-next')));
    document.querySelectorAll('peptia-objectives').forEach(root=>init(root,root.querySelector('.protocol-track'),root.querySelector('.prev'),root.querySelector('.next')));
    document.querySelectorAll('.product-media-slider').forEach(root=>init(root,root.querySelector('.product__media-list'),root.querySelector('.slider-button--prev'),root.querySelector('.slider-button--next')));
    document.querySelectorAll('.splide__track').forEach(track=>{const root=track.parentElement.closest('.splide');if(root)init(root,track,root.querySelector('.splide__arrow--prev'),root.querySelector('.splide__arrow--next'),'splide');});
    document.querySelectorAll('peptia-protocol-carousel').forEach(root=>init(root,root.querySelector('[data-track]'),root.querySelector('[data-direction="-1"]'),root.querySelector('[data-direction="1"]')));
    document.querySelectorAll('.peptia-reviews__track').forEach(track=>init(track.parentElement,track,null,null,'scroll'));
    document.querySelectorAll('.peptia-science__stats-track').forEach(track=>{
      const root=track.parentElement;
      if (root.querySelectorAll('.peptia-science__dot').length>1) init(root,track,null,null,'dots');
    });
  };
  let queued=false;
  const schedule=()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;scan();});};
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',scan,{once:true}); else scan();
  document.addEventListener('shopify:section:load',schedule);
  document.addEventListener('shopify:section:unload',schedule);
  new MutationObserver(records=>{if(records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1&&!n.matches('.peptia-side-controls,svg,path'))))schedule();}).observe(document.documentElement,{childList:true,subtree:true});
})();
